export enum EventTypeEnum {
    Alarm = 0,
    Fuel = 1,
    Area = 2
}
